import axios from "axios";
import { bookDomain } from "./consts";
import iziToast from "izitoast";

const instance = axios.create();
instance.defaults.baseURL = bookDomain.prod;
instance.defaults.headers.common["appId"] = 1;
instance.defaults.headers.common["platform"] = "web";
instance.interceptors.response.use(
  function (response) {
    if (response.status == 200) {
      return response.data;
    } else {
      iziToast.error({
        title: "error",
        message: response.error,
        close: false,
        drag: false,
      });
      return Promise.reject(response);
    }
  },
  function (error) {
    if (error.config.method == 'head') return Promise.reject(error);
    iziToast.error({
      title: "error",
      message: error.message,
      close: false,
      drag: false,
    });
    return Promise.reject(error);
  }
);

const get = (url, params) => instance.get(url, { params });

const post = (url, body) => instance.post(url, body);

const head = (url) => instance.head(url);

const postParams = (url, params, body) => instance.post(url, body, { params });

export { head, get, post, postParams };
